<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Disposiciones</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Disposiciones</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="d-flex justify-content-between">
                                <h3 class="card-title">Lista de Disposiciones</h3>
                                <PrimaryButton class="btn btn-primary" data-toggle="modal" data-target="#modal-lg"
                                    @click="openCreationForm">
                                    {{ addNewRecord }}
                                </PrimaryButton>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex">
                                <input type="text" class="form-control" placeholder="Buscar Disposiciones..."
                                    v-model="searchStringModel" />
                            </div>

                            <div class="position-relative col-sm-12">
                                <DisbursementsTable :list="paginatedCreditFacilities" @sort="sortBy($event)"
                                    @edit="openEditionForm" />
                                <Pagination v-if="filteredS.length > itemsPerPage" :list="filteredS"
                                    :items-per-page="itemsPerPage" :current-page="currentPage"
                                    @current-page="setCurrentPage($event)" />

                                <Modal>
                                    <AddForm v-if="modalContent == 1 && editing == false"
                                        :prospectus="selectedProspectus" :loanApplication="selectedLoanApplication"
                                        :temp-values="tempValues" @show-table="showTable($event)"
                                        @close-modal="modalStatus" @change-modal-content="modalContent = $event">
                                    </AddForm>

                                    <div v-if="modalContent === 2">
                                        <ProspectsTable @back-to-form="backToForm($event)"
                                            @selectedProspectus="selectedProspectus = $event" :list="getAllProspects"
                                            :itemsPerPage="itemsPerPageModal" :currentPage="currentPageModal">
                                        </ProspectsTable>
                                        <Pagination :list="getAllProspects" :itemsPerPage="itemsPerPageModal"
                                            :currentPage="currentPageModal" @current-page="currentPageModal = $event">
                                        </Pagination>
                                    </div>

                                    <div v-if="modalContent === 3">
                                        <LoanApplicationsTable :list="getLoanApplications"
                                            @selected-item="selectedLoanApplication = $event"
                                            @back-to-form="backToForm($event)" :currentPage="currentPageModal">
                                        </LoanApplicationsTable>
                                        <Pagination :list="getLoanApplications" :itemsPerPage="itemsPerPageModal"
                                            :currentPage="currentPageModal" @current-page="currentPageModal = $event">
                                        </Pagination>
                                    </div>

                                    <EditForm v-if="modalContent == 4 && editing == true"
                                        :credit-facility="selectedCreditFacility" :temp-values="tempValues"
                                        @show-table="showTable($event)" @close-modal="modalStatus"
                                        @change-modal-content="modalContent = $event">
                                    </EditForm>
                                </Modal>
                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>

<!--Option API-->
<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import DisbursementsTable from '@/Components/Tables/DisbursementsTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import Modal from '@/Components/Bootstrap/Modal.vue';
import AddForm from '@/Components/Forms/Disbursements/Add.vue';
import EditForm from '@/Components/Forms/Disbursements/Edit.vue';
import ProspectsTable from '@/Components/Tables/ProspectsMinTable.vue';
import LoanApplicationsTable from '@/Components/Tables/LoanApplicationsMinTable.vue';
import { useIndividualProspectsStore } from "@/pinia/Prospects/individual.module";
import { sharedStore } from '@/pinia/sharedStore.module';
import { useCreditFacilities } from '@/pinia/creditFacilities.module';
import Prospectus from '@/Models/Prospects';

export default {
    components: {
        DisbursementsTable,
        Pagination,
        Modal,
        AddForm,
        EditForm,
        ProspectsTable,
        LoanApplicationsTable
    },
    data() {
        return {
            modalContent: 0,
            editing: false,
            currentPageModal: 1,
            itemsPerPageModal: 10,
            tempValues: {},
            selectedProspectus: new Prospectus({}),
            selectedLoanApplication: {},
            selectedCreditFacility: {}
        }
    },
    computed: {
        ...mapState(sharedStore, ['getAllProspects', 'getLoanApplications']),
        ...mapState(useCreditFacilities, ['itemsPerPage', 'currentPage', 'searchString']),
        ...mapGetters(useCreditFacilities, ['paginatedS', 'filteredS']),
        addNewRecord() {
            return this.$getLocaleMessage('buttons', 'addNewRecord')
        },
        paginatedCreditFacilities() {
            return this.paginatedS;
        },
        searchStringModel: {
            get() {
                return this.$pinia.state.value.creditFacilities?.searchString || '';
            },
            set(value) {
                this.setSearchString(value);
            }
        }
    },
    methods: {
        ...mapActions(useIndividualProspectsStore, ['fetchActiveMixedProspects']),
        ...mapActions(sharedStore, ['setSelectedProspectus', 'setSelectedLoanApplication', 'resetProspectsList', 'resetLoanApplicationsList']),
        ...mapActions(useCreditFacilities, ['fetchCreditFacilities', 'sortBy', 'filteredS', 'setCurrentPage', 'setSearchString']),
        openCreationForm() {
            this.modalContent = 1;
            this.editing = false;
            //#1 Carga de prospectos
            this.fetchActiveMixedProspects();
        },
        openEditionForm(creditFacility) {
            this.selectedCreditFacility = creditFacility;
            this.modalContent = 4;
            this.editing = true
        },
        showTable(data) {

            /**Identificamos que se cambia la selección del prospecto y entonces limpiamos el contenido del formulario para seleccionar nuevos valores */
            if(data.contentNumber === 2){
                this.selectedLoanApplication = {};
                this.setSelectedLoanApplication();
                this.resetLoanApplicationsList();
            }

            this.tempValues = data;
            this.modalContent = data.contentNumber;
        },
        modalStatus(status) {
            if (status) {
                $('#modal-lg').modal('hide');
            }
        },
        backToForm() {
            this.modalContent = this.editing ? 4 : 1;
        }
    },
    watch: {
        selectedProspectus: {
            handler(newItem) {
                if (newItem && newItem.prospectusId !== 0) {
                    this.setSelectedProspectus(newItem.prospectusId);
                }
            },
            immediate: true,
        },
        selectedLoanApplication: {
            handler(newItem) {
                if (newItem && newItem.id !== null && newItem.id !== undefined) { //&& newItem.personTypeId !== null && newItem.personTypeId !== undefined
                    this.setSelectedLoanApplication(newItem.id);
                }
            },
            immediate: true,
        }
    },
    mounted() {
        $('#modal-lg').on('hidden.bs.modal', () => {
            this.modalContent = 0;
            this.editing = false;
            this.selectedProspectus = new Prospectus();
            this.selectedLoanApplication = {};
            this.tempValues = {};
            this.setSelectedProspectus();
            this.resetProspectsList();
            this.setSelectedLoanApplication();
            this.resetLoanApplicationsList();
        });
        this.fetchCreditFacilities();
    }
}
</script>